import listComponent from '@/util/proto/listComponent'

const buyOptionsDisplay = (d) => {
  return `${d.clearingTypeText} ${d.stagesPrice.toFixed(2)} x ${d.stagesNum}期`
}

export default {
  extends: listComponent,

  data() {
    return {
      columns: [
        {
          title: '序号',
          type: 'index',
          align:'center',
          width: 60,
        },
        {
          title: '姓名',
          key: 'name',
          width: 120,
        },
        {
          title: '联系电话',
          key: 'phone',
          minWidth: 120,
        },
        {
          title: '车辆编号',
          key: 'carNo',
          minWidth: 90,
        },
        {
          title: '分期',
          key: 'buyOptionsDisplay',
          minWidth: 150,
        },
        {
          title: '逾期开始时间',
          key: 'arrearsTimeText',
          minWidth: 120,
        },
        {
          title: '逾期天数',
          key: 'num',
          minWidth: 100,
        },
        {
          title: '逾期总额',
          key: 'balanceText',
          minWidth: 100,
        },
      ],
      data: [],
      options:{},
      visible:false,
    }
  },


  methods: {

    init(options) {
      this.options = options
      this.visible = true
      this.search()
    },
    search(){

      let params = { search:this.options || {}, pageSize: this.page.pageSize, pageNum: this.page.pageNum , orders:this.page.orders }
      this.loading = true

      this.$request.statsOverdueCar(params).then(resp => {
        this.loading = false
        this.data = this.$utils.conv(this.$utils.conv(resp.data.list || [] , { 'arrearsTime':'date' , balance:Math.abs , clearingType:'clearingType'}) , {buyOptionsDisplay})
        this.page.total = resp.data.total
      })
    },
  },

  render(){
    const data = this.data || {}

    const title = '逾期详情'
    return (
      <sl-side-panel v-model={this.visible} mask-closable={false} title={title}>
        <sl-table showHeader={true} loading={this.loading} page={this.page} columns={this.columns} data={this.data} on-change={this.$tableChange} />

      </sl-side-panel>
    )
  }
}
